@if (headerTemplate(); as header) {
  <div class="header">
    <ng-container [ngTemplateOutlet]="header" />
  </div>
} @else if (title()) {
  <h2 class="title" [class.dialog-only]="dialogOnlyTitle()" data-test="tlm-options-sheet:title">
    {{ title() }}
  </h2>
}

<button
  type="button"
  class="close"
  data-test="tlm-options-sheet:close"
  [attr.aria-label]="closeLabelKey() | translate"
  (click)="dismiss()"
>
  <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"
    />
  </svg>
</button>

@for (group of optionGroups(); track $index) {
  <div class="group">
    @for (option of group; track option.id) {
      <button
        type="button"
        class="option"
        [class.destructive]="option.destructive"
        [disabled]="option.disabled"
        [attr.data-test]="'tlm-options-sheet:option:' + option.id"
        (click)="select(option)"
      >
        <span class="label">{{ option.label }}</span>
        @if (iconTemplate(); as icon) {
          <ng-container
            [ngTemplateOutlet]="icon"
            [ngTemplateOutletContext]="{ $implicit: option }"
          />
        }
      </button>
    }
  </div>
}
